import React from 'react';

export const SkeletonMaterial: React.FC = () => (
  <div className="flex flex-col gap-3">
    <div className="flex mx-auto h-16 w-[101rem] bg-gray-100 animate-pulse rounded-3xl"></div>
    <div className="flex mx-auto flex-row gap-3 h-full">
      <div className="flex flex-col w-[78rem] gap-3 h-full">
        <div className="h-80 bg-gray-100 animate-pulse rounded-xl"></div>
        {[1, 2, 3].map((key) => (
          <div className="h-24 bg-gray-100 animate-pulse rounded-xl" key={key}></div>
        ))}
      </div>
      <div className="flex flex-col w-[22rem] gap-3 h-full">
        {[1, 2, 3].map((key) => (
          <div className="h-24 bg-gray-100 animate-pulse rounded-xl" key={key}></div>
        ))}
        <div className="h-80 bg-gray-100 animate-pulse rounded-full"></div>
      </div>
    </div>
  </div>
);
